<template>
  <div class="relative">
    <navigation-menu />
    <AccountBlock/>
  </div>
</template>

<script>
import NavigationMenu from "@/components/menu/NavigationMenu.vue";
import AccountBlock from "@/components/AccountBlock.vue";

export default {
  name: "MenuAccountPage",
  components: {
    AccountBlock,
    "navigation-menu": NavigationMenu,
  }
};
</script>

